<template>
  <div class="draggable-list">
    <table class="table">
      <thead>
        <tr>
          <th>ID</th>
          <th>アカウント名</th>
          <th>アカウント名（カナ）</th>
          <th>所属店舗</th>
          <th>権限</th>
          <th style="width: 150px;">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="account in accounts" :key="account.id">
          <td>{{ account.id }}</td>
          <td>{{ account.accountName }}</td>
          <td>{{ account.accountNameKana }}</td>
          <td>{{ account.storeName }}</td>
          <td>{{ account.authorityName }}</td>
          <td class="actions-cell">
            <div class="action-buttons">
              <button
                @click="$emit('edit', account)"
                class="btn btn-icon btn-primary"
                :disabled="userAuthority !== ADMIN_ID"
                :class="{ 'btn-disabled': userAuthority !== ADMIN_ID }"
              >
                <i class="fa fa-edit"></i>
              </button>
            </div>
          </td>
        </tr>
        <tr v-if="accounts.length === 0">
          <td colspan="6" class="text-center">アカウントがありません</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import constants from '../../constants/constants.json';
export default {
  name: 'AccountTable',
  props: {
    accounts: {
      type: Array,
      required: true,
      default: () => []
    },
    userAuthority: {
      type: Number,
      required: true
    }
  },
  computed: {
    ADMIN_ID() {
      return constants.Authority.ADMIN.id;
    }
  },
}
</script>

<style scoped>
.draggable-list {
  width: 100%;
}

.actions-cell {
  white-space: nowrap;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.btn-icon {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--gray-medium);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 49px;
  height: 49px;
  box-sizing: border-box;
}

.table th {
  font-weight: bold;
  background-color: #195983;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 49px;
  height: 49px;
  box-sizing: border-box;
}

.btn-disabled {
  opacity: 0.2;
  pointer-events: none;
}
</style>
